/**
 * The main component that renders single TabComponent
 * instances.
 */

import {
    Component,
    ContentChildren,
    QueryList,
    AfterContentInit,
    ViewChild,
    ComponentFactoryResolver,
    ViewContainerRef,
    OnInit
} from '@angular/core';
import * as _ from 'lodash';

import { APP_COMPONENTS } from '../index';//'./components/index';
import { DynamicTabsDirective } from './dynamic-tabs.directive';
import { SubscribeService } from '../../services/subscribe.service';
@Component({
    selector: 'my-tabs',
    templateUrl: './tabs.component.html'
})
export class TabsComponent implements OnInit {
    dynamicTabs = [];

    /*@ContentChildren(EmptyTabComponent)
    tabs: QueryList < EmptyTabComponent > ;*/

    /*@ViewChild(DynamicTabsDirective)
    dynamicTabPlaceholder: DynamicTabsDirective;*/

    /*
      Alternative approach of using an anchor directive
      would be to simply get hold of a template variable
      as follows
    */
    @ViewChild('container', { read: ViewContainerRef }) dynamicTabPlaceholder;

    constructor(private _componentFactoryResolver: ComponentFactoryResolver, public subSer: SubscribeService) {
    }

    // contentChildren are set
    ngAfterContentInit() {
        /*// get all active tabs
        let activeTabs = this.tabs.filter((tab) => tab.active);

        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }*/

    }
    ngOnInit() {
        let that = this;
        this.subSer.publishDeleteTab().subscribe(($e) => {
            that.closeActiveTab();
        });
    }


    // openTab(title: string, component, data, isCloseable = false, params: object) {
    //     //debugger;
    //     // get a component factory for our EmptyTabComponent
    //     let componentFactory = this._componentFactoryResolver.resolveComponentFactory(component);
    //
    //     // fetch the view container reference from our anchor directive
    //     //let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
    //
    //     // alternatively...
    //     let viewContainerRef = this.dynamicTabPlaceholder;
    //
    //     // create a component instance
    //     let componentRef = viewContainerRef.createComponent(componentFactory);
    //
    //     // set the according properties on our component instance
    //     let instance = componentRef.instance;
    //     instance.title = title;
    //     //instance.template = template;
    //     instance.dataContext = data;
    //     instance.isCloseable = isCloseable;
    //     instance.params = params;
    //     // remember the dynamic component for rendering the
    //     // tab navigation headers
    //     this.dynamicTabs.push(componentRef.instance);
    //
    //     // set it active
    //     this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
    //
    //     /*var height = window.innerHeight - 190;
    //     $('.tabContent .ngx-datatable').height(height);
    //     $('.tabContent .ngx-datatable .datatable-body').height(height-100);*/
    // }
    openTab(tabObj: any, isCloseable: boolean, params = {}) {
        
        let tabInd = _.findIndex(this.dynamicTabs, { tabID: tabObj['id'], tabOriParams: tabObj['params'] });
        if (tabInd == -1){// || tabObj['type'] == 'multiple') {
            let component = _.find(APP_COMPONENTS, { name: tabObj['id'] });
            //let component = tabObj['component'];
            // get a component factory for our EmptyTabComponent
            let componentFactory = this._componentFactoryResolver.resolveComponentFactory(component);

            // fetch the view container reference from our anchor directive
            //let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;

            // alternatively...
            let viewContainerRef = this.dynamicTabPlaceholder;

            // create a component instance
            let componentRef = viewContainerRef.createComponent(componentFactory);

            // set the according properties on our component instance
            let instance = componentRef.instance;
            instance.title = (params['mode'] == 'Edit' ? ('Edit - ' + tabObj['title']) : tabObj['title']);
            instance.tabID = tabObj['id'];
            instance.tabOriParams = tabObj['params'];
            instance.dataContext = tabObj;
            instance.isCloseable = isCloseable;
            instance.params = params;
            // remember the dynamic component for rendering the
            // tab navigation headers
            this.dynamicTabs.push(componentRef.instance);

            tabInd = this.dynamicTabs.length - 1;
        } 
        // else if(tabInd != undefined){

        // }
        // set it active
        this.selectTab(this.dynamicTabs[tabInd]);

        /*var height = window.innerHeight - 190;
        $('.tabContent .ngx-datatable').height(height);
        $('.tabContent .ngx-datatable .datatable-body').height(height-100);*/
    }

    selectTab(tab: any) {
        if (tab) {
            // deactivate all tabs
            //this.tabs.toArray().forEach(tab => tab.active = false);
            this.dynamicTabs.forEach(tab => tab.active = false);

            // activate the tab the user has clicked on.
            tab.active = true;
        } else {
            tab = this.dynamicTabs[this.dynamicTabs.length - 1];
            if (tab)
                tab.active = true;
        }
    }

    closeTab(tab: any) {
        for (let i = 0; i < this.dynamicTabs.length; i++) {
            if (this.dynamicTabs[i] === tab) {
                // remove the tab from our array
                this.dynamicTabs.splice(i, 1);

                // destroy our dynamically created component again
                //let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
                let viewContainerRef = this.dynamicTabPlaceholder;
                viewContainerRef.remove(i);

                let tab = this.dynamicTabs[this.dynamicTabs.length - 1];
                this.selectTab(tab);
                break;
            }
        }
    }

    closeActiveTab() {
        //if (allowDelete == true) {
        let activeTabs = this.dynamicTabs.filter((tab) => tab.active);
        if (activeTabs.length > 0) {
            // close the 1st active tab (should only be one at a time)
            this.closeTab(activeTabs[0]);
        }
        //}
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/home/tabs.component.ts